import React from 'react';
import s from './Trailer.module.css';
import Ribbon from '../../Ribbon/Ribbon';

function Trailer({ trailerBackground, trailerSVG }) {
  return (
    <section className={s.section}>
      <div
        className={s.div}
        style={{
          background: `url(${trailerBackground})`,
          backgroundSize: 'cover',
        }}
      >
        <svg className={s.svg}>
          <use href={trailerSVG}></use>
        </svg>
      </div>

      <div className={s.ribbon}>
        <Ribbon className={s.ribbon} />
      </div>
    </section>
  );
}

export default Trailer;
